// MAIN
export const SET_REDIRECT_PATH = "MAIN/SET_REDIRECT_PATH";
export const SET_MOBILE_MENU_OPEN = "MAIN/SET_MOBILE_MENU_OPEN";
export const SET_THEME_MODE = "MAIN/SET_THEME_MODE";
export const SET_ONBOARDING_CHECK_PENDING = "MAIN/SET_ONBOARDING_CHECK_PENDING";

// CUSTOMER MANAGEMENT
export const SIGNUP = "CUSTOMER_MANAGEMENT/SIGNUP";
export const SIGN_IN = "CUSTOMER_MANAGEMENT/SIGN_IN";
export const CHANGE_PASSWORD = "CUSTOMER_MANAGEMENT/CHANGE_PASSWORD";
export const REFRESH_TOKEN = "CUSTOMER_MANAGEMENT/REFRESH_TOKEN";
export const LOGOUT = "CUSTOMER_MANAGEMENT/LOGOUT";
export const SOCIAL_SIGN_IN = "CUSTOMER/SOCIAL_SIGN_IN";
export const SOCIAL_SIGNUP = "CUSTOMER/SOCIAL_SIGNUP";
export const EMAIL_VERIFICATION = "CUSTOMER/EMAIL_VERIFICATION";
export const PHONE_VERIFICATION = "CUSTOMER/PHONE_VERIFICATION";
export const INITIATE_FORGOT_PASSWORD = "CUSTOMER/INITIATE_FORGOT_PASSWORD";
export const FORGOT_PASSWORD_RESET = "CUSTOMER/FORGOT_PASSWORD_RESET";

export const SUBMIT_DOCUMENTS = "CUSTOMER_MANAGEMENT/SUBMIT_DOCUMENTS";
export const SUBMIT_EMPLOYMENT_DETAILS =
  "CUSTOMER_MANAGEMENT/SUBMIT_EMPLOYMENT_DETAILS";
export const UPDATE_EMPLOYMENT_DETAILS =
  "CUSTOMER_MANAGEMENT/UPDATE_EMPLOYMENT_DETAILS";
export const FETCH_EMPLOYMENT_DETAILS =
  "CUSTOMER_MANAGEMENT/FETCH_EMPLOYMENT_DETAILS";

export const FETCH_FINANCIAL_DETAILS =
  "CUSTOMER_MANAGEMENT/FETCH_FINANCIAL_DETAILS";
export const SUBMIT_FINANCIAL_DETAILS =
  "CUSTOMER_MANAGEMENT/SUBMIT_FINANCIAL_DETAILS";
export const UPDATE_FINANCIAL_DETAILS =
  "CUSTOMER_MANAGEMENT/UPDATE_FINANCIAL_DETAILS";

export const FETCH_PERSONAL_DETAILS =
  "CUSTOMER_MANAGEMENT/FETCH_PERSONAL_DETAILS";
export const SUBMIT_PERSONAL_DETAILS =
  "CUSTOMER_MANAGEMENT/SUBMIT_PERSONAL_DETAILS";
export const UPDATE_PERSONAL_DETAILS =
  "CUSTOMER_MANAGEMENT/UPDATE_PERSONAL_DETAILS";

export const FETCH_COUNTRIES = "CUSTOMER_MANAGEMENT/FETCH_COUNTRIES";
export const FETCH_INDUSTRIES = "CUSTOMER_MANAGEMENT/FETCH_INDUSTRIES";
export const SEND_OTP = "CUSTOMER_MANAGEMENT/SEND_OTP";
export const VERIFY_OTP = "CUSTOMER_MANAGEMENT/VERIFY_OTP";

export const FETCH_ONBOARDING_STATUS =
  "CUSTOMER_MANAGEMENT/FETCH_ONBOARDING_STATUS";
export const ONBOARDING_VALIDATE =
  "CUSTOMER_MANAGEMENT/ONBOARDING_VALIDATE";
export const ONBOARDING_REGISTER =
  "CUSTOMER_MANAGEMENT/ONBOARDING_REGISTER";
export const FETCH_TRADING_EXPERIENCE =
  "CUSTOMER_MANAGEMENT/FETCH_TRADING_EXPERIENCE";
export const SUBMIT_TRADING_EXPERIENCE =
  "CUSTOMER_MANAGEMENT/SUBMIT_TRADING_EXPERIENCE";
export const UPDATE_TRADING_EXPERIENCE =
  "CUSTOMER_MANAGEMENT/UPDATE_TRADING_EXPERIENCE";

export const SUBMIT_TRADING_ACCOUNTS =
  "CUSTOMER_MANAGEMENT/SUBMIT_TRADING_ACCOUNTS";
export const FETCH_TRADING_ACCOUNTS =
  "CUSTOMER_MANAGEMENT/FETCH_TRADING_ACCOUNTS";
export const UPDATE_LEVERAGE = "CUSTOMER_MANAGEMENT/UPDATE_LEVERAGE";
export const INITIATE_RESET_PASSWORD =
  "CUSTOMER_MANAGEMENT/INITIATE_RESET_PASSWORD";
export const RESET_PASSWORD = "CUSTOMER_MANAGEMENT/RESET_PASSWORD";
export const FETCH_SWAP_FREE_DETAILS = "CUSTOMER_MANAGEMENT/FETCH_SWAP_FREE_DETAILS";
export const SUBMIT_SWAP_FREE = "CUSTOMER_MANAGEMENT/SUBMIT_SWAP_FREE";

export const FETCH_USER = "CUSTOMER_MANAGEMENT/FETCH_USER";

export const SET_SIGNUP_DETAILS = "CUSTOMER_MANAGEMENT/SET_SIGNUP_DETAILS";
export const HYDRATE_USER = "CUSTOMER_MANAGEMENT/HYDRATE_USER";

export const FETCH_ACCOUNT_TYPES = "CUSTOMER_MANAGEMENT/FETCH_ACCOUNT_TYPES";

export const FETCH_PLATFORM_SERVERS =
  "CUSTOMER_MANAGEMENT/FETCH_PLATFORM_SERVERS";

export const FETCH_INTRODUCING_BROKER_APPLICATION =
  "CUSTOMER_MANAGEMENT/FETCH_INTRODUCING_BROKER_APPLICATION";
export const SUBMIT_INTRODUCING_BROKER_APPLICATION =
  "CUSTOMER_MANAGEMENT/SUBMIT_INTRODUCING_BROKER_APPLICATION";
export const FETCH_REFERRAL_LINKS = "CUSTOMER_MANAGEMENT/FETCH_REFERRAL_LINKS";
export const SUBMIT_REFERRAL_LINK = "CUSTOMER_MANAGEMENT/SUBMIT_REFERRAL_LINK";

export const FETCH_NEWS = "CUSTOMER_MANAGEMENT/FETCH_NEWS";

export const FETCH_CONTACTS = "CUSTOMER_MANAGEMENT/FETCH_CONTACTS";
export const SUBMIT_CONTACT = "CUSTOMER_MANAGEMENT/SUBMIT_CONTACT";

// CLIENT CABINET
export const FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION";
export const FETCH_CLIENT_CABINET_CLIENT_COMMISSION =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_CLIENT_COMMISSION";
export const FETCH_CLIENT_CABINET_COMMISSION_SETTINGS =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_COMMISSION_SETTINGS";
export const FETCH_CLIENT_CABINET_IB_COMMISSIONS =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_IB_COMMISSIONS";
export const FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD";
export const FETCH_CLIENT_CABINET_IB_REFERRALS =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_IB_REFERRALS";
export const FETCH_CLIENT_CABINET_IB_TRANSACTIONS =
  "CUSTOMER-MANAGEMENT/FETCH_CLIENT_CABINET_IB_TRANSACTIONS";

// GOOGLE ANALYTICS
export const MONITORING_CLIENTS = "CUSTOMER-MANAGEMENT/MONITORING_CLIENTS";

// META ANALYTICS
export const MONITORING_META_CLIENTS =
  "CUSTOMER-MANAGEMENT/MONITORING_META_CLIENTS";

// SOCIAL TRADING
export const FETCH_SOCIAL_TRADING_PROVIDERS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDERS";
export const FETCH_SOCIAL_TRADING_PROVIDER_OFFERS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_OFFERS";
export const SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER =
  "CUSTOMER_MANAGEMENT/SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER";
export const SUBMIT_SOCIAL_TRADING_PROVIDER =
  "CUSTOMER_MANAGEMENT/SUBMIT_SOCIAL_TRADING_PROVIDER";
export const SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER =
  "CUSTOMER_MANAGEMENT/SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER";
export const FETCH_SOCIAL_TRADING_PROVIDER_CONFIG =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_CONFIG";
export const FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS";
export const FETCH_SOCIAL_TRADING_PROVIDER_DETAILS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_DETAILS";
export const FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART";
export const FETCH_SOCIAL_TRADING_PROVIDER_METRICS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_METRICS";

export const FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS";
export const FETCH_SOCIAL_TRADING_PROVIDER_DEALS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_DEALS";
export const UPDATE_SOCIAL_TRADING_PROVIDER =
  "CUSTOMER_MANAGEMENT/UPDATE_SOCIAL_TRADING_PROVIDER";
export const FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO";
export const UPDATE_SOCIAL_TRADING_SUBSCRIPTION =
  "CUSTOMER_MANAGEMENT/UPDATE_SOCIAL_TRADING_SUBSCRIPTION";
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS";
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS";
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS";
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS";
export const FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK";
export const UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK =
  "CUSTOMER_MANAGEMENT/UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK";
export const DELETE_SOCIAL_TRADING_SUBSCRIPTION =
  "CUSTOMER_MANAGEMENT/DELETE_SOCIAL_TRADING_SUBSCRIPTION";
export const FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO";
export const FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS";
export const FETCH_SOCIAL_TRADING_OFFER_DETAILS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_OFFER_DETAILS";
export const FETCH_SOCIAL_TRADING_FEES =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_FEES";
export const SUBMIT_PROVIDER_APPLICATION =
  "CUSTOMER_MANAGEMENT/SUBMIT_PROVIDER_APPLICATION";
export const FETCH_SOCIAL_TRADING_RATE_PROFILE =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_RATE_PROFILE";
export const FETCH_SOCIAL_TRADING_HISTORY_INDICATORS =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_HISTORY_INDICATORS";
export const FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT";
export const FETCH_SOCIAL_TRADING_TRADE_REPORT =
  "CUSTOMER_MANAGEMENT/FETCH_SOCIAL_TRADING_TRADE_REPORT";

// PAYMENTS
export const FETCH_WALLET = "PAYMENTS/FETCH_WALLET";
export const FETCH_TRANSACTIONS = "PAYMENTS/FETCH_TRANSACTIONS";
export const INITIATE_STK_PUSH = "PAYMENTS/INITIATE_STK_PUSH";
export const WITHDRAW = "PAYMENTS/WITHDRAW";
export const FETCH_EXCHANGE_RATE = "PAYMENTS/FETCH_EXCHANGE_RATE";
export const TRANSFERS = "PAYMENTS/TRANSFERS";
export const INITIATE_CARD_PAYMENT = "PAYMENTS/INITIATE_CARD_PAYMENT";
export const INITIATE_BANK_TRANSFER = "PAYMENTS/INITIATE_BANK_TRANSFER";
export const INITIATE_MERCHANT_PAYMENT = "PAYMENTS/INITIATE_MERCHANT_PAYMENT";
export const FETCH_PAYMENT_TRANSACTION = "PAYMENTS/FETCH_PAYMENT_TRANSACTION";
export const INITIATE_CASHIA_WITHDRAWAL = "PAYMENTS/INITIATE_CASHIA_WITHDRAWAL";
